/*
 * © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useEffect } from 'react';

/**
 * hook call to dynamically set the document title
 * called in pageTemplate if pageTitle prop provided
 * otherwise user will need to call this function on page creation
 * @param title
 * @param prevailOnUnmount
 */
export var useDocumentTitle = function useDocumentTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Promethean';
  var prevailOnUnmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  useEffect(function () {
    document.title = title;
  }, [title]);
  useEffect(function () {
    return function () {
      if (!prevailOnUnmount) {
        document.title = 'Promethean';
      }
    };
  }, []);
};